<template>
  <v-card
    class="mx-auto"
    max-width="100%"
    outlined
  >
    <v-list-item three-line>
      <v-list-item-content>
        <v-list-item-title class="headline mb-1" id="title">{{ name }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-card-actions class="card-actions">
      <v-container fluid>


          <!-- mobile -->
          <v-layout wrap align-center hidden-md-and-up>  
            <v-flex xs4 sm6 md6 class="search-bar">
              <v-text-field
                solo
                label="Search"
                append-icon="search"
                v-model="search"
                @keyup="$emit('update:inputData', search);"
              ></v-text-field>
            </v-flex>
            <v-flex xs8 sm4 md3 offset-sm2 offset-md3 class="text-right">
              <v-menu>
                <template v-slot:activator="{ on }" class="hidden-md-and-up">
                  <v-btn
                    text
                    v-on="on"
                    class="filters"
                  >
                    <v-icon left>fas fa-sliders-h</v-icon>
                    Filters
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="(item, index) in items"
                    :key="index"
                    @click=""
                  >
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-menu>
                <template v-slot:activator="{ on }">
                  <v-btn
                    text
                    v-on="on"
                    class="sorting"
                  >
                    Newest top
                    <v-icon right>fas fa-caret-down</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="(item, index) in items"
                    :key="index"
                    @click=""
                  >
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-flex>
          </v-layout>

      </v-container>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  data() {
      return {
          search: '',
      }
  },
  props: [ 'name', 'items', 'inputData' ]
}
</script>
